import { AccountSliceState } from 'src/redesign/features/Account/store/types';
import { FEATURE_NAME } from 'src/redesign/features/Account/store/constants';
import { createSlice } from '@reduxjs/toolkit';
import {
  getAccountConnected,
  getAccountInfo,
  logoutAccount,
  uploadAvatar,
  updateAccount,
} from 'src/redesign/features/Account/store/actions';
import { createSiteData } from 'src/features/utils';

const initialState: AccountSliceState = {
  account: null,
  connected: null,
  connectedLoading: false,
  connectedError: null,
  isLoading: false,
  error: null,
  site: null,
  role: 'Attendee',
};

export const accountSlice = createSlice({
  name: FEATURE_NAME,
  initialState,
  reducers: {
    autoUpdateSiteData: (state) => {
      const urlSearchParams = new URLSearchParams(window.location.search);
      state.site = createSiteData(urlSearchParams);
    },
    switchRole: (state, action) => {
      state.role = action.payload;
      // Update account.is_event_organizer to match the role
      if (state.account) {
        state.account.is_event_organizer = action.payload === 'host';
      }
    },
  },
  extraReducers: (builder) => {
    builder.addCase(getAccountInfo.fulfilled, (state, action) => {
      state.error = null;
      state.isLoading = false;
      state.account = action.payload.data;
    });
    builder.addCase(getAccountInfo.pending, (state) => {
      state.account = null;
      state.error = null;
      state.isLoading = true;
    });
    builder.addCase(getAccountInfo.rejected, (state, action) => {
      state.error = action.error.message;
    });
    builder.addCase(getAccountConnected.fulfilled, (state, action) => {
      state.connectedError = null;
      state.connectedLoading = false;
      state.connected = action.payload.data;
    });
    builder.addCase(getAccountConnected.rejected, (state, action) => {
      state.connected = null;
      state.connectedError = action.error.message;
      state.connectedLoading = false;
    });
    builder.addCase(getAccountConnected.pending, (state) => {
      state.connectedError = null;
      state.connectedLoading = true;
    });
    builder.addCase(logoutAccount.fulfilled, () => {
      window.location.href = process.env.DASHBOARD_CLIENT_URL || '/';
      setTimeout(() => {
        window.location.reload();
      }, 1000);
    });
    builder.addCase(logoutAccount.rejected, () => {
      window.location.href = process.env.DASHBOARD_CLIENT_URL || '/';
      setTimeout(() => {
        window.location.reload();
      }, 1000);
    });
    builder.addCase(uploadAvatar.fulfilled, (state, action) => {
      if (state.account) {
        state.account.avatar_url = action.payload.data.avatar_url;
      }
    });
    builder.addCase(updateAccount.fulfilled, (state, action) => {
      if (state.account && action.payload.data) {
        state.account = { ...state.account, ...action.payload.data };
      }
    });
  },
});

export const accountActions = accountSlice.actions;
